import { ReportView } from './report-view'
import { reportType } from '../types'

const reportTypes: reportType[] = [
	'DOMAIN',
	'CAMPAIGN',
	'KEYWORD',
	'PLACEMENT',
	'CUSTOM_RULES'
]

export const AvailableReports = () => {
	return (
		<>
			<div className="space-y-4 pt-4">
				{reportTypes.map((type) => (
					<ReportView type={type} key={type} />
				))}
			</div>
		</>
	)
}
